define('calendarView',[
  'app',
  'require',
  'module',
  'marionette',
  'underscore',
  'jquery',
  'moment',
  'template!calendarView',
  'entities/calendar_events',
  'entities/admin/tasks',
  'fullcalendar'
], function (
  App,
  require,
  module,
  Marionette,
  _,
  $,
  moment,
  Tpl
) {
  'use strict';

  var DEFAULT_COLOR = '#2f8f91';
  var TASK_COLOR = '#f59e0b';

  module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'calendar-page-view',

    ui: {
      calendar: '.calendar-container',
      title: '.js-title',
      prev: '.js-prev',
      next: '.js-next',
      today: '.js-today',
      views: '.js-view',
      newEvent: '.js-new-event',
      pending: '.js-pending',
      pendingBadge: '.js-pending .cal-badge',
      toggleTasks: '.js-toggle-tasks'
    },

    events: {
      'click @ui.prev': 'onPrev',
      'click @ui.next': 'onNext',
      'click @ui.today': 'onToday',
      'click @ui.views': 'onChangeView',
      'click @ui.newEvent': 'onNewEvent',
      'click @ui.pending': 'onShowPending',
      'click @ui.toggleTasks': 'onToggleTasks'
    },

    initialize: function () {
      this.isManager = false;
      this.groups = [];
      // Tasks are an opt-in overlay: the calendar opens with events only and
      // the "Tasks" toggle brings the due-dated tasks in.
      this.showTasks = false;
    },

    serializeData: function () {
      return {};
    },

    onShow: function () {
      this.renderCalendar();
      this.loadContext();
      // Keep the grid filling the viewport so day cells show as many events as
      // fit (eventLimit:true) rather than a fixed cap — re-fit on window resize.
      this._onWindowResize = _.debounce(_.bind(this.resizeCalendar, this), 150);
      $(window).on('resize.cal-' + this.cid, this._onWindowResize);
    },

    onDestroy: function () {
      $(window).off('resize.cal-' + this.cid);
      if (this.ui.calendar && this.ui.calendar.fullCalendar) {
        try {
          this.ui.calendar.fullCalendar('destroy');
        } catch (e) { /* already torn down */ }
      }
    },

    // Available height for the grid: from the container's top edge down to the
    // bottom of the viewport (minus a little breathing room). Viewport-relative
    // via getBoundingClientRect so it's correct regardless of page scroll.
    calendarHeight: function () {
      var el = this.ui.calendar && this.ui.calendar[0];
      if (!el) { return 600; }
      var top = el.getBoundingClientRect().top;
      // Room below the grid for the panel's + page's bottom padding, so the
      // filled grid doesn't push a page scrollbar.
      var bottomGap = 44;
      return Math.max(420, Math.round($(window).height() - top - bottomGap));
    },

    // Re-fit the grid to the viewport after a window resize.
    resizeCalendar: function () {
      if (this.isDestroyed || !this.ui.calendar || !this.ui.calendar.fullCalendar) { return; }
      this.ui.calendar.fullCalendar('option', 'height', this.calendarHeight());
    },

    renderCalendar: function () {
      this.ui.calendar.fullCalendar({
        // The native chrome is replaced by our own branded toolbar.
        header: false,
        defaultView: 'month',
        locale: moment.locale(),
        firstDay: 1,
        // A definite height (fills the viewport) gives each day cell a real
        // amount of vertical space, so eventLimit:true can show as many events
        // as fit and only spill the overflow into a "+X more" link.
        height: this.calendarHeight(),
        fixedWeekCount: false,
        navLinks: true,
        nowIndicator: true,
        selectable: true,
        selectHelper: true,
        editable: true,
        eventLimit: true,
        events: _.bind(this.fetchEvents, this),
        viewRender: _.bind(this.onViewRender, this),
        eventRender: _.bind(this.onEventRender, this),
        select: _.bind(this.onSelect, this),
        eventClick: _.bind(this.onEventClick, this),
        eventDrop: _.bind(this.onEventChange, this),
        eventResize: _.bind(this.onEventChange, this)
      });
    },

    /** Keep our toolbar title and active view button in sync with the grid. */
    onViewRender: function (view) {
      this.ui.title.text(view.title);
      this.ui.views.removeClass('is-active');
      this.$('.js-view[data-view="' + view.name + '"]').addClass('is-active');
    },

    onPrev: function () {
      this.ui.calendar.fullCalendar('prev');
    },

    onNext: function () {
      this.ui.calendar.fullCalendar('next');
    },

    onToday: function () {
      this.ui.calendar.fullCalendar('today');
    },

    onChangeView: function (e) {
      this.ui.calendar.fullCalendar('changeView', $(e.currentTarget).data('view'));
    },

    loadContext: function () {
      App.request('calendar:context').done(_.bind(function (ctx) {
        this.isManager = !!(ctx && ctx.manager);
        this.userpidSecId = ctx ? ctx.userpidSecId : null;
        this.groups = (ctx && ctx.groups) || [];
        if (this.isManager) {
          this.ui.pending.removeClass('hidden');
          this.refreshPendingBadge();
        }
      }, this));
    },

    refreshPendingBadge: function () {
      if (!this.isManager) {
        return;
      }
      App.request('calendar:pending').done(_.bind(function (list) {
        var count = list ? list.length : 0;
        this.ui.pendingBadge.text(count).toggleClass('hidden', count === 0);
        this.ui.pending.toggleClass('has-pending', count > 0);
      }, this));
    },

    fetchEvents: function (start, end, timezone, callback) {
      var self = this;
      App.request('calendar:events', start.valueOf(), end.valueOf())
        .done(function (list) {
          var events = _.map(list || [], self.toFcEvent, self);
          if (!self.showTasks) {
            callback(events);
            return;
          }
          self.fetchTasks(start, end, function (taskEvents) {
            callback(events.concat(taskEvents));
          });
        })
        .fail(function () {
          callback([]);
        });
    },

    /**
     * Overlay the current user's tasks that fall due within the window. The
     * tasks API has no date filter, so we pull the user's tasks and filter by
     * dateDue client-side. Tasks are read-only here; clicking opens the task
     * dialog.
     */
    fetchTasks: function (start, end, cb) {
      var self = this;
      var fromMs = start.valueOf();
      var toMs = end.valueOf();
      var url = App.request('tasks:get-url', {first: 0, pageSize: 500, forMe: true});
      $.ajax({type: 'GET', url: url})
        .done(function (items) {
          var events = [];
          _.each(items || [], function (t) {
            if (!t.dateDue) {
              return;
            }
            // dateDue is an ISO string, not epoch ms — parse before comparing.
            var due = moment(t.dateDue).valueOf();
            if (due >= fromMs && due < toMs) {
              events.push(self.toTaskFcEvent(t));
            }
          });
          cb(events);
        })
        .fail(function () { cb([]); });
    },

    toTaskFcEvent: function (t) {
      return {
        id: 'task-' + t.secId,
        title: (t.done ? '☑ ' : '☐ ') + this.taskLabel(t),
        start: moment(t.dateDue),
        allDay: false,
        editable: false,
        color: TASK_COLOR,
        isTask: true,
        done: !!t.done,
        raw: t
      };
    },

    /** A concise label for a task, from its linked order/customer/product. */
    taskLabel: function (t) {
      if (t.refCommandLine && t.refCommandLine.purchaseOrderId) {
        return t.refCommandLine.purchaseOrderId;
      }
      if (t.refEndUser) {
        return t.refEndUser.code || t.refEndUser.endUserId ||
          _.i18n('common.customer', null, 'Customer');
      }
      if (t.refProduct) {
        return t.refProduct.cCode || t.refProduct.name ||
          _.i18n('common.product', null, 'Product');
      }
      if (t.comments && t.comments.length && t.comments[0].content) {
        return t.comments[0].content;
      }
      return _.i18n('common.task', null, 'Task');
    },

    toFcEvent: function (json) {
      var end = null;
      if (json.end) {
        // Stored all-day end is the inclusive last day at midnight; FullCalendar
        // expects an EXCLUSIVE end, so render it as the following midnight.
        end = json.allDay ?
          moment(json.end).startOf('day').add(1, 'day') :
          moment(json.end);
      }
      // Prefix a bell when a reminder is set (0 = "at start" counts), and the
      // group name for group events so the audience is legible at a glance.
      var hasReminder = json.reminderMinutesBefore === 0 || json.reminderMinutesBefore;
      var groupPrefix = (json.type === 'GROUP' && json.groupName) ? '[' + json.groupName + '] ' : '';
      return {
        id: json.secId,
        title: (hasReminder ? '🔔 ' : '') + groupPrefix + (json.title || ''),
        start: moment(json.start),
        end: end,
        allDay: json.allDay,
        color: json.color || DEFAULT_COLOR,
        // Recurring occurrences are not drag-editable in v1 (would need
        // per-occurrence detach); only single events the user owns are.
        editable: json.canEdit && !json.occurrenceDate,
        raw: json
      };
    },

    /**
     * Render events as soft tinted pills with a colour-coded left accent and
     * dark, readable text. Pending vacation requests read as faded/dashed so
     * their status is legible without a separate label.
     */
    onEventRender: function (event, element) {
      var color = event.color || DEFAULT_COLOR;
      var raw = event.raw || {};
      element.css({
        'background-color': this.tint(color, 0.14),
        'border': 'none',
        'border-left': '3px solid ' + color,
        'border-radius': '5px',
        'color': '#243b53',
        'padding': '1px 6px',
        'font-weight': '500'
      });
      element.find('.fc-time').css('color', color);
      if (raw.status === 'PENDING_APPROVAL') {
        element.css({'opacity': '0.55', 'border-left-style': 'dashed'});
      } else if (raw.status === 'REJECTED') {
        element.css({'opacity': '0.4', 'text-decoration': 'line-through'});
      }
      if (event.isTask && event.done) {
        element.css({'opacity': '0.5', 'text-decoration': 'line-through'});
      }
      element.attr('title', this.eventTooltip(event, raw));
      return element;
    },

    /** Native hover text: title, who created it and, for decided vacations, who decided. */
    eventTooltip: function (event, raw) {
      var lines = [event.title];
      if (raw.ownerName) {
        lines.push(_.i18n('calendar.createdBy', null, 'Created by') + ' ' + raw.ownerName);
      }
      if (raw.approvedByName && (raw.status === 'CONFIRMED' || raw.status === 'REJECTED')) {
        lines.push((raw.status === 'REJECTED' ?
          _.i18n('calendar.rejectedBy', null, 'Rejected by') :
          _.i18n('calendar.approvedBy', null, 'Approved by')) + ' ' + raw.approvedByName +
          (raw.approvedAt ? ', ' + moment(raw.approvedAt).format('DD/MM/YYYY HH:mm') : ''));
      }
      return lines.join('\n');
    },

    /** Hex (#rgb or #rrggbb) → rgba string at the given alpha. */
    tint: function (hex, alpha) {
      if (!hex) {
        return 'rgba(47,143,145,' + alpha + ')';
      }
      var h = hex.replace('#', '');
      if (h.length === 3) {
        h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
      }
      var n = parseInt(h, 16);
      return 'rgba(' + ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + alpha + ')';
    },

    refetch: function () {
      this.ui.calendar.fullCalendar('refetchEvents');
      this.refreshPendingBadge();
    },

    onNewEvent: function () {
      this.openEditor(this.buildModel({
        start: moment().startOf('hour').valueOf(),
        end: moment().startOf('hour').add(1, 'hour').valueOf(),
        allDay: false
      }));
    },

    onSelect: function (start, end) {
      var allDay = !start.hasTime();
      // FullCalendar's selection end is exclusive; store the inclusive last day.
      var endMs = allDay ? end.clone().subtract(1, 'day').valueOf() : end.valueOf();
      this.openEditor(this.buildModel({
        start: start.valueOf(),
        end: endMs,
        allDay: allDay
      }));
      this.ui.calendar.fullCalendar('unselect');
    },

    onEventClick: function (fcEvent) {
      if (fcEvent.isTask) {
        var raw = fcEvent.raw;
        require(['tasksEditView'], function (TasksEditView) {
          TasksEditView.prototype.open({model: App.request('tasks:model', raw)});
        });
        return;
      }
      this.openEditor(this.buildModel(fcEvent.raw));
    },

    onEventChange: function (fcEvent, delta, revertFunc) {
      var raw = fcEvent.raw || {};
      if (!fcEvent.editable) {
        revertFunc();
        return;
      }
      var model = this.buildModel(raw);
      if (fcEvent.allDay) {
        // Normalise to the stored convention: midnight bounds, inclusive end.
        model.set('start', fcEvent.start ?
          fcEvent.start.clone().startOf('day').valueOf() : raw.start);
        model.set('end', fcEvent.end ?
          fcEvent.end.clone().subtract(1, 'day').startOf('day').valueOf() :
          (fcEvent.start ? fcEvent.start.clone().startOf('day').valueOf() : raw.end));
      } else {
        model.set('start', fcEvent.start ? fcEvent.start.valueOf() : raw.start);
        model.set('end', fcEvent.end ? fcEvent.end.valueOf() : raw.end);
      }
      model.set('allDay', fcEvent.allDay);
      model.save()
        .done(_.bind(this.refetch, this))
        .fail(function () { revertFunc(); });
    },

    buildModel: function (json) {
      return App.request('calendar:event:model', json);
    },

    openEditor: function (model) {
      require(['calendarEditView'], _.bind(function (CalendarEditView) {
        CalendarEditView.prototype.open({
          model: model,
          isManager: this.isManager,
          groups: this.groups,
          userpidSecId: this.userpidSecId,
          onSaved: _.bind(this.refetch, this),
          onDeleted: _.bind(this.refetch, this)
        });
      }, this));
    },

    onShowPending: function () {
      require(['calendarPendingView'], _.bind(function (CalendarPendingView) {
        CalendarPendingView.prototype.open({
          onChanged: _.bind(this.refetch, this)
        });
      }, this));
    },

    onToggleTasks: function () {
      this.showTasks = !this.showTasks;
      this.ui.toggleTasks.toggleClass('is-on', this.showTasks);
      this.refetch();
    }
  });
});

